import * as React from 'react';

import classnames from '../../../core/utils/classnames.tsx';

export type StatusTone = 'neutral' | 'agent' | 'success' | 'warning' | 'danger';

const DOT_CLASS: Record<StatusTone, string> = {
    neutral: 'bg-content-medium',
    agent: 'bg-surface-agent-strong',
    success: 'bg-surface-success-strong',
    warning: 'bg-surface-warning-strong',
    danger: 'bg-surface-danger-strong',
};

const TEXT_CLASS: Record<StatusTone, string> = {
    neutral: 'text-content-strong',
    agent: 'text-content-agent-default',
    success: 'text-content-success-strong',
    warning: 'text-content-warning-strong',
    danger: 'text-content-danger-default',
};

const BADGE_CLASS: Record<StatusTone, string> = {
    neutral: 'bg-surface-medium border-line-strong',
    agent: 'bg-surface-agent-weak border-line-agent-strong',
    success: 'bg-surface-success-weak border-line-success-strong',
    warning: 'bg-surface-warning-weak border-line-warning-strong',
    danger: 'bg-surface-danger-weak border-line-danger-strong',
};

interface StatusProps {
    tone: StatusTone;
    children: React.ReactNode;
    className?: string;
}

export const StatusDot = ({ tone, className }: { tone: StatusTone; className?: string }) => (
    <span
        aria-hidden
        className={classnames('inline-block h-2.5 w-2.5 flex-none rounded-full', DOT_CLASS[tone], className)}
    />
);

export const StatusLabel = ({ tone, children, className }: StatusProps) => (
    <span className={classnames('inline-flex items-center gap-1 font-medium', TEXT_CLASS[tone], className)}>
        <StatusDot tone={tone} />
        {children}
    </span>
);

const RunStatusBadge = ({ tone, children, className }: StatusProps) => (
    <span
        className={classnames(
            'inline-flex items-center gap-1.5 whitespace-nowrap rounded border border-solid px-2 py-1 text-xs font-medium',
            BADGE_CLASS[tone],
            TEXT_CLASS[tone],
            className
        )}
    >
        <StatusDot tone={tone} />
        {children}
    </span>
);

export default RunStatusBadge;
